import { baseState, baseMutations } from '@/store/mixins'
import cashRequestReport from '@/api/report/cash-request-report'

export const state = {
    ...baseState,
    employees: [],
    banks: [],
    currencies: []
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_EMPLOYEES (state, data) { state.employees = data },
    SET_BANKS (state, data) { state.banks = data },
    SET_CURRENCIES (state, data) { state.currencies = data }
}

export const actions = {
    async fetchEmployees ({ commit }, params = {}) {
        const { data } = await cashRequestReport.employees({ params })
        commit('SET_EMPLOYEES', data)
    },
    async fetchBanks ({ commit }) {
        const { data } = await cashRequestReport.banks()
        commit('SET_BANKS', data)
    },
    async fetchCurrencies ({ commit }) {
        const { data } = await cashRequestReport.currencies()
        commit('SET_CURRENCIES', data)
    },
    async fetch ({ commit }, params = {}) {
        const response = await cashRequestReport.index({ params })
        commit('RECEIVE_RESOURCES', response)
        return response
    },
    previewPdf (_, params = {}) {
        return cashRequestReport.pdf({ params })
    },
    exportExcel (_, params = {}) {
        return cashRequestReport.exportExcel(params)
    }
}
